/**
 * TANITIM GÖRSELLERİ (10.10.2026) — dışarıdan hiçbir şey yüklenmez; ikisi de
 * sayfanın içinde çizilir ve renkleri temadan alır (koyu temaya kendiliğinden
 * uyar).
 *
 *  - `GizlilikSemasi`: "kasa cihazda açılır; bulutta yalnızca şifreli kopya;
 *    sunucudan yalnızca fiyat ve kur gelir" — Gizlilik ve Profiller kartında.
 *  - `RaporOrnegi`: başlık alanında küçük bir rapor görünümü. Rakamlar UYDURMA
 *    ve sabit metin (hesaplanmaz, motor değildir); kutunun üstünde "Örnek veri"
 *    yazar ve ekran okuyucuya rakamlar okunmaz (yalnızca açıklaması).
 */

import { M } from "../../dil";

/** Cihaz → kendi bulutu (şifreli kap) ve sunucu → cihaz (fiyat ve kur). */
export function GizlilikSemasi() {
  return (
    <figure className="m-0">
      <svg
        viewBox="0 0 320 186"
        role="img"
        aria-labelledby="pf-gizlilik-semasi-baslik"
        className="h-auto w-full max-w-[340px] text-ink"
      >
        <title id="pf-gizlilik-semasi-baslik">{M.anaSayfa.gorsel.semaBaslik}</title>
        <defs>
          <marker id="pf-ok" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
            <path d="M0 0 10 5 0 10z" fill="var(--pf-deco-4)" />
          </marker>
        </defs>

        {/* Cihaz */}
        <rect x="14" y="30" width="72" height="116" rx="12" fill="var(--pf-surface)" stroke="var(--pf-deco-4)" strokeWidth="2" />
        <rect x="40" y="38" width="20" height="3" rx="1.5" fill="var(--pf-deco-4)" opacity=".5" />
        <rect x="26" y="52" width="48" height="6" rx="3" fill="var(--pf-deco-1-soft)" />
        <rect x="26" y="63" width="36" height="6" rx="3" fill="var(--pf-deco-1-soft)" />
        <rect x="26" y="74" width="42" height="6" rx="3" fill="var(--pf-deco-1-soft)" />
        <circle cx="50" cy="110" r="15" fill="var(--pf-deco-4)" />
        <path
          d="M44 110v-3a6 6 0 0 1 12 0v3m-14 0h16v10h-16z"
          fill="none"
          stroke="var(--pf-deco-fg)"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <text x="50" y="18" textAnchor="middle" fontSize="13" fontWeight="600" fill="currentColor">
          {M.anaSayfa.gorsel.cihaz}
        </text>
        <text x="50" y="166" textAnchor="middle" fontSize="11" fill="var(--pf-text-muted)">
          {M.anaSayfa.gorsel.cihazAlt}
        </text>

        {/* Kendi bulutunuz */}
        <path
          d="M236 58a14 14 0 0 1-1-27.9A20 20 0 0 1 273 26a15 15 0 0 1 9 30z"
          fill="var(--pf-surface)"
          stroke="var(--pf-deco-2)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect x="249" y="34" width="16" height="13" rx="2" fill="var(--pf-deco-2)" />
        <path d="M253 34v-3a4 4 0 0 1 8 0v3" fill="none" stroke="var(--pf-deco-2)" strokeWidth="1.8" />
        <text x="257" y="12" textAnchor="middle" fontSize="13" fontWeight="600" fill="currentColor">
          {M.anaSayfa.gorsel.bulut}
        </text>
        <text x="257" y="72" textAnchor="middle" fontSize="11" fill="var(--pf-text-muted)">
          {M.anaSayfa.gorsel.bulutAlt}
        </text>

        {/* Parafon sunucusu */}
        <rect x="228" y="110" width="58" height="16" rx="3" fill="var(--pf-surface)" stroke="var(--pf-deco-3)" strokeWidth="2" />
        <rect x="228" y="130" width="58" height="16" rx="3" fill="var(--pf-surface)" stroke="var(--pf-deco-3)" strokeWidth="2" />
        <circle cx="238" cy="118" r="2" fill="var(--pf-deco-3)" />
        <circle cx="238" cy="138" r="2" fill="var(--pf-deco-3)" />
        <text x="257" y="104" textAnchor="middle" fontSize="13" fontWeight="600" fill="currentColor">
          {M.anaSayfa.gorsel.sunucu}
        </text>
        <text x="257" y="162" textAnchor="middle" fontSize="11" fill="var(--pf-text-muted)">
          {M.anaSayfa.gorsel.sunucuAlt1}
        </text>
        <text x="257" y="174" textAnchor="middle" fontSize="11" fill="var(--pf-text-muted)">
          {M.anaSayfa.gorsel.sunucuAlt2}
        </text>

        {/* Oklar */}
        <path d="M92 66C140 50 180 44 214 44" fill="none" stroke="var(--pf-deco-4)" strokeWidth="2" markerEnd="url(#pf-ok)" />
        <text x="152" y="40" textAnchor="middle" fontSize="11" fill="var(--pf-text-muted)">
          {M.anaSayfa.gorsel.sifreliYedek}
        </text>
        <path
          d="M222 128C180 128 140 120 94 108"
          fill="none"
          stroke="var(--pf-deco-4)"
          strokeWidth="2"
          strokeDasharray="5 4"
          markerEnd="url(#pf-ok)"
        />
        <text x="156" y="138" textAnchor="middle" fontSize="11" fill="var(--pf-text-muted)">
          {M.anaSayfa.gorsel.fiyatKur}
        </text>
      </svg>
    </figure>
  );
}

const ORNEK_SATIRLAR = [
  { ...M.anaSayfa.gorsel.ornek.hisse, yon: "arti" },
  { ...M.anaSayfa.gorsel.ornek.fon, yon: "arti" },
  { ...M.anaSayfa.gorsel.ornek.abd, yon: "eksi" },
] as const;

/** Başlık alanındaki küçük rapor görünümü. Rakamlar uydurma; "Örnek veri" yazar. */
export function RaporOrnegi() {
  return (
    <figure className="m-0 w-full max-w-sm">
      <figcaption className="sr-only">{M.anaSayfa.gorsel.ornekAciklama}</figcaption>
      <div aria-hidden="true" className="rounded-xl border border-line bg-surface p-4 text-ink shadow-xl">
        <div className="flex items-center justify-between gap-2">
          <p className="text-[13px] font-semibold">{M.anaSayfa.gorsel.raporBaslik}</p>
          <span className="rounded-full bg-surface-2 px-2 py-0.5 text-[11px] font-semibold text-muted">{M.anaSayfa.gorsel.ornekVeri}</span>
        </div>
        <div className="mt-3 flex h-2 overflow-hidden rounded-full">
          <span className="bg-deco-1" style={{ width: "45%" }} />
          <span className="bg-deco-2" style={{ width: "30%" }} />
          <span className="bg-deco-3" style={{ width: "25%" }} />
        </div>
        <ul className="mt-3 divide-y divide-line text-[12px]">
          {ORNEK_SATIRLAR.map((s, i) => (
            <li key={s.ad} className="flex items-center gap-2 py-1.5">
              <span className={["h-2 w-2 shrink-0 rounded-full", ["bg-deco-1", "bg-deco-2", "bg-deco-3"][i]].join(" ")} />
              <span className="flex-1 text-muted">{s.ad}</span>
              <span className="pf-num tabular-nums">{s.deger}</span>
              <span className={["w-14 text-right tabular-nums", s.yon === "arti" ? "text-gain" : "text-loss"].join(" ")}>
                {s.degisim}
              </span>
            </li>
          ))}
        </ul>
        <div className="mt-1 flex items-center justify-between border-t border-line pt-2 text-[13px] font-semibold">
          <span>{M.anaSayfa.gorsel.toplam}</span>
          <span className="tabular-nums">{M.anaSayfa.gorsel.toplamDeger}</span>
        </div>
        <div className="mt-3 rounded-lg bg-surface-2 p-2.5 text-[11px] leading-relaxed text-muted">
          <p className="font-semibold text-ink">{M.anaSayfa.gorsel.nereden}</p>
          <p>{M.anaSayfa.gorsel.neredenAyrinti}</p>
        </div>
      </div>
    </figure>
  );
}
